import RequestApi from "../../modules/requestApi";
import config from "../../../config.js";

const state = {
  // список опросов
  pollList: [],
  // признак загрузки списка опросов
  pollIsLoaded: false,
  // признак для фильтрации списка опросов
  pollsFilter: 0,
  // параметры по умолчанию при создании опроса
  pollDefaultParams: {
    name: "Опрос",
    // начало и окончание периода проведения
    start: null,
    end: null,
    // тип ответов на вопрос (один, несколько или оценка)
    type: "one",
    // вопрос
    title: "",
    params: {
      // для предварительного просмотра на экране
      preview: {
        poll: `/uploads/default/poll.jpg`,
      },
      /**
       * кому показывать рекламу:
       * new - новым клиентам
       * again - пришедшим повторно
       * many - пришедшим более нескольких раз (counts)
       */
      clients: {
        new: false,
        again: false,
        many: false,
        counts: 0,
      },
    },
    polls: [{ title: "" }],
    hotspots: [],
  },
};

const mutations = {
  SET_POLL_LIST(state, data) {
    state.pollList = data;
  },
  SET_POLL_IS_LOADED(state, data) {
    state.pollIsLoaded = data;
  },
  SET_POLL_ITEM(state, data) {
    // определяем индекс по id
    const index = state.pollList.findIndex((item) => item.id === data.id);
    if (index !== -1) {
      // перезаписываем элемент, через удаление, иначе реактивность не срабатывает
      state.pollList.splice(index, 1, { ...state.pollList[index], ...data });
    }
  },
  SET_POLL_ANSWER(state, data) {
    const index_poll = state.pollList.findIndex(
      (item) => item.id === data.parent_id
    );
    if (index_poll !== -1) {
      if (data.deleted) {
        const index_answer = state.pollList[index_poll].polls.findIndex(
          (item) => item.id === data.id
        );
        if (index_answer != -1)
          state.pollList[index_poll].polls.splice(index_answer, 1);
      } else {
        state.pollList[index_poll].polls.push(data);
      }
    }
  },
  SET_POLL_HOTSPOT(state, data) {
    const index_poll = state.pollList.findIndex(
      (item) => item.id === data.poll_id
    );
    if (index_poll !== -1) {
      if (data.deleted) {
        const index_hotspot = state.pollList[index_poll].hotspots.findIndex(
          (item) => item.id === data.id
        );
        if (index_hotspot != -1)
          state.pollList[index_poll].hotspots.splice(index_hotspot, 1);
      } else {
        state.pollList[index_poll].hotspots.push({
          id: data.id,
          address: data.address,
          title: data.title,
        });
      }
    }
  },
  SET_POLLS_FILTER(state, data) {
    state.pollsFilter = data;
  },
};

const actions = {
  // получаем список опросов
  pollListLoad({ commit, state }) {
    if (!state.pollIsLoaded) {
      return new Promise((resolve, reject) => {
        RequestApi.pollList()
          .then((data) => {
            commit("SET_POLL_LIST", data);
            commit("SET_POLL_IS_LOADED", true);
          })
          .catch(reject);
      });
    }
  },
  // создаем новый опрос
  createPoll({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.createPoll(params)
        .then((data) => {
          commit("SET_POLL_LIST", [...state.pollList, data]);
          resolve(data);
        })
        .catch(reject);
    });
  },
  // редактируем опрос
  editPoll({ commit }, params) {
    if (params.poll.end === "") {
      params.poll.end = null;
    }
    if (params.poll.start === "") {
      params.poll.start = null;
    }
    return new Promise((resolve, reject) => {
      RequestApi.editPoll(params)
        .then((data) => {
          commit("SET_POLL_ITEM", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  // дублирование опроса
  copyPoll({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.copyPoll(params)
        .then((data) => {
          commit("SET_POLL_LIST", [...state.pollList, data]);
          resolve(data);
        })
        .catch(reject);
    });
  },
  // удаление опроса
  deletePoll({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.deletePoll(params)
        .then((data) => {
          commit(
            "SET_POLL_LIST",
            state.pollList.filter((item) => item.id !== params.id)
          );
          resolve(data);
        })
        .catch(reject);
    });
  },
  // удаление опроса
  deleteAnswerPoll({ commit }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.deleteAnswerPoll(params)
        .then((data) => {
          // убрать в item polls удаленный вопрос
          commit("SET_POLL_ANSWER", data);
          resolve(data);
        })
        .catch(reject);
    });
  },
  // восстановление опроса
  recoveryPoll({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.recoveryPoll(params)
        .then((data) => {
          commit("SET_POLL_LIST", [...state.pollList, data]);
          resolve(data);
        })
        .catch(reject);
    });
  },
  // восстановление варианта ответа
  recoveryAnswerPoll({ commit }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.recoveryAnswerPoll(params)
        .then((data) => {
          commit("SET_POLL_ANSWER", data);
          // добавить в item polls вопрос
          resolve(data);
        })
        .catch(reject);
    });
  },
  // прикрепление опроса к хотспоту
  pinHotspot({ commit }, params) {
    return new Promise((resolve, reject) => {
      RequestApi.hotspotEdit({
        id: params.id,
        poll_id: params.deleted ? null : params.poll_id,
      })
        .then((data) => {
          commit("SET_HOTSPOT_ITEM", data);
          commit("SET_POLL_HOTSPOT", params);
          resolve(data);
        })
        .catch(reject);
    });
  },
};

const getters = {
  pollList: (state) => (filtered) => {
    let result = state.pollList;
    // текущие кампании
    if (filtered === 1) {
      result = result.filter(
        (item) =>
          (item.start && new Date(item.start)) < new Date() &&
          item.end &&
          new Date(item.end) > new Date()
      );
    } // запланированные кампании
    if (filtered === 2) {
      result = result.filter(
        (item) => item.start && new Date(item.start) > new Date()
      );
    }
    // завершенные кампании
    if (filtered === 3) {
      result = result.filter(
        (item) => item.end && new Date(item.end) < new Date()
      );
    }
    return result;
  },
  pollIsLoaded: (state) => {
    return state.pollIsLoaded;
  },
  getPoll: (state) => (id) => {
    return state.pollList.find((item) => item.id === id);
  },
  pollDefaultParams: (state) => {
    return state.pollDefaultParams;
  },
  // возвращает признак для фильтрации рекламы
  pollsFilter: (state) => {
    return state.pollsFilter;
  },
};

export default {
  state,
  mutations,
  actions,
  getters,
};
